import {
  StyledRange,
  TimeStyles,
} from 'components/DatePickerStyles/DatePickerStyles'
import Label from 'components/Form/Label'
import CalendarIcon from 'components/icons/CalendarIcon'
import Clock from 'components/icons/Clock'
import {
  DateStylePaper,
  DivWrapper,
  FormItem,
  TwoFields,
} from 'modules/Drive/Partials/ConfirmDriveDrawer/Partials/FormSection/Style/style'
import { Form } from 'modules/Students/Partials/AddNewStudentDrawer/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

const FormSection = ({
  formId = 'confirmDrive',
  onSubmitFormData,
  dateFormat = 'DD-MM-YYYY',
  isReschedule,
  selectedDrive,
  form,
}) => {
  let isRangePicker = true
  const [startTime, setStartTime] = useState(0)
  const [endTime, setEndTime] = useState(0)

  useEffect(() => {
    if (isReschedule) {
      let startTimeArr = selectedDrive?.startTime?.split(':')
      let endTimeArr = selectedDrive?.endTime?.split(':')
      let startTimeVal = moment()
        .hours(+startTimeArr[0])
        .minutes(+startTimeArr[1])
        .unix()
      let endTimeVal = moment()
        .hours(+endTimeArr[0])
        .minutes(+endTimeArr[1])
        .unix()
      setStartTime(startTimeVal)
      setEndTime(endTimeVal)
      form.setFieldsValue({
        driveDate: [
          moment(selectedDrive?.startDate),
          moment(selectedDrive?.endDate),
        ],
        startTime: moment(selectedDrive?.startTime, 'HH:mm'),
        endTime: moment(selectedDrive?.endTime, 'HH:mm'),
      })
    }
  }, [])
  const onDOBChange = (date, dateString) => {}

  const onStartTimeChange = time => {
    setStartTime(moment(time).unix())
  }
  const onEndTimeChange = time => {
    setEndTime(moment(time).unix())
  }
  return (
    <Form
      scrollToFirstError
      onFinish={onSubmitFormData}
      id={formId}
      form={form}
      layout="vertical"
    >
      <div>
        <TwoFields centerVertically>
          <Label required={true}>
            Select Drive Date(s) <span>*</span>
          </Label>
        </TwoFields>
        <FormItem
          name="driveDate"
          rules={[
            {
              type: 'array',
              required: true,
              message: 'Please Select Drive Date!',
            },
          ]}
        >
          {isRangePicker ? (
            <StyledRange
              suffixIcon={<CalendarIcon />}
              id="date_of_birth"
              width="100%"
              color="#010E30"
              opacity="1"
              format={dateFormat}
              onChange={onDOBChange}
              disabledDate={d => !d || d.isBefore(moment().subtract(1, 'day'))}
            />
          ) : (
            <DateStylePaper
              suffixIcon={<CalendarIcon />}
              id="date_of_birth"
              width="100%"
              color="#010E30"
              opacity="1"
              placeholder={dateFormat}
              format={dateFormat}
              onChange={onDOBChange}
              disabledDate={d => !d || d.isBefore(moment().subtract(1, 'day'))}
            />
          )}
        </FormItem>
      </div>
      <TwoFields spaceBetween>
        <DivWrapper>
          <Label required={true}>Start Time*</Label>
          <FormItem
            name="startTime"
            rules={[{ required: true, message: 'Please Select Start Time!' }]}
          >
            <TimeStyles
              format="HH:mm"
              showSecond={false}
              suffixIcon={<Clock />}
              id="startTime"
              width="100%"
              color="#010E30"
              opacity="1"
              placeholder="--:--am"
              onChange={onStartTimeChange}
            />
          </FormItem>
        </DivWrapper>

        <DivWrapper>
          <Label required={true}>End Time*</Label>
          <FormItem
            name="endTime"
            rules={[
              { required: true, message: 'Please Select End Time!' },
              {
                message: 'End time should be greater than start time!',
                validator: (_, value) => {
                  if (startTime < endTime) {
                    return Promise.resolve()
                  } else {
                    return Promise.reject(
                      new Error('End time should be greater than start time')
                    )
                  }
                },
              },
            ]}
          >
            <TimeStyles
              format="HH:mm"
              showSecond={false}
              suffixIcon={<Clock />}
              id="endTime"
              width="100%"
              color="#010E30"
              opacity="1"
              placeholder="--:--pm"
              onChange={onEndTimeChange}
            />
          </FormItem>
        </DivWrapper>
      </TwoFields>
    </Form>
  )
}

export default FormSection
